import { RequestClientService, ResponseType } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { QuestionsDict, SaveQuestionCommentsRequest } from "../../models/onboarding/rightship-onboarding.models";
import { FormAttachmentListAttributeResponse as FormAttachmentListAttributeResponse, GetFormAttachmentListAttributeRequest, PreviousFormCommentModel } from "../../models/onboarding/rightship-onboarding.models";
import { SubtaskCorrespondenceEmailModel } from "../../models/vetting/vetting.models";

@autoinject
export class RightShipOnboardingService {

    constructor(private requestClient: RequestClientService) {
    }

    public isCancelled(onboardingRequestGuid: string): Promise<boolean> {
        return this.requestClient.post(`RightShipOnboarding/IsCancelled`, {}, { onboardingRequestGuid });
    }

    public getRecipientsForNeedMoreInfo(workflowStateId: number): Promise<any[]> {
        return this.requestClient.get(`RightShipOnboarding/GetRecipientsForNeedMoreInfo`, { workflowStateId });
    }

    public exportTQ(onboardingRequestGuid: string, name: string): Promise<any> {
        return this.requestClient.get<Blob>(`RightShipOnboarding/ExportTQ/${onboardingRequestGuid}`, {}, ResponseType.Blob).then(x => {
            this.requestClient.downloadFile(x, name + ".csv");
        }, e => { throw e; });
    }

    public getPreviousFormComment(vesselApplicationFormId: number): Promise<PreviousFormCommentModel> {
        return this.requestClient.get(`RightShipOnboarding/GetPreviousFormComment`, { vesselApplicationFormId });
    }

    public sendFormAttachmentsEmail(request): Promise<void> {
        return this.requestClient.post(`RightShipOnboarding/SendFormAttachmentsEmail`, {}, request);
    }

    public getHelideckReport(onboardingRequestGuid: string, name: string): Promise<any> {
        return this.requestClient.get<Blob>(`RightShipOnboarding/GetHelideckReport/${onboardingRequestGuid}`, {}, ResponseType.Blob).then(x => {
            this.requestClient.downloadFile(x, 'helideck_' + name + ".pdf");
        }, e => { throw e; });
    }

    public getRecipientsForRequestEmailForm(onboardingRequestGuid: string): Promise<SubtaskCorrespondenceEmailModel[]> {
        return this.requestClient.get(`RightShipOnboarding/GetRecipientsForRequestEmailForm`, { onboardingRequestGuid });
    }

    public downloadFormTemplate(onboardingRequestGuid: string, onboadingName: string): Promise<any> {
        return this.requestClient.get<Blob>(`RightShipOnboarding/DownloadFormTemplate/${ onboardingRequestGuid }`, { }, ResponseType.Blob).then(x => {
            this.requestClient.downloadFile(x, (onboadingName ?? 'Form') + '.xlsx');
        }, e => { throw e; });
    }

    public uploadPrefilledFormTemplate(file: File): Promise<{[column: string]: any}>
    {
        return this.requestClient.postFormData<{[column: string]: any}>(`RightShipOnboarding/UploadPrefilledFormTemplate`, {file: file});
    }

    public saveDraftComment(assignmentId: number, comment: string): Promise<void> {
        return this.requestClient.post(`RightShipOnboarding/SaveDraftComment`, {}, { assignmentId: assignmentId, comment: comment });
    }

    public saveQuestionComments(request: SaveQuestionCommentsRequest): Promise<void> {
        return this.requestClient.post(`RightShipOnboarding/SaveQuestionComments`, {}, request);
    }

    public getQuestionComments(onboardingRequestId: number): Promise<QuestionsDict> {
        return this.requestClient.get(`RightShipOnboarding/GetQuestionComments/${onboardingRequestId}`, {});
    }
    
    public getFormAttachmentAttributes(request: GetFormAttachmentListAttributeRequest): Promise<FormAttachmentListAttributeResponse> {
        return this.requestClient.post(`RightShipOnboarding/GetFormAttachmentAttributes`, {}, request); 
    }
}